module.exports = __webpack_public_path__ + "static/media/55_000043.c7442443.jpg";